//JavaScript file
/**
 * Config.js
 *
 *
 * @author  王中艺<wangzy_smile@qq.com>
 * @date    2018-08-01 23:45:08
 */

export default {

    //后台地址
    api_url : 'https://api.unnda.cn:8081',
    //m2地址
    m2_url : 'http://m2.unnda.cn',
    //富甲三国地址
    fjsg_url: 'https://www.unnda.cn/fjsg',
    //佣兵传说官网地址
    lapis_url: 'https://www.unnda.cn/lapis'
}



// WEBPACK FOOTER //
// ./src/common/Config.js